export default __webpack_public_path__ + "static/media/ArrowSeeMore.42d9fe36.svg";